<div class="container-fluid">
  <div class="row shadow-sm headerbar">
    <div class="col-md-2 bg-white">
      <div class="p-2">
        <img src={{user?.partnerId.logoPath}} class="img-fluid logo-img mt-1 mb-1" style="width: 120px; height: 50px; object-fit: contain;">
      </div>
    </div>
    <div class="col-md-10 bg-white">
      <div class="d-flex justify-content-between mt-1 mb-1">
        <button type="button" class="showMenu btn btn-light bg-white border-0 btn-sm"
          (click)="toggleMenu()" [attr.aria-expanded]="menuOpen" aria-controls="sideMenubar"
          aria-label="Toggle navigation menu">
          <i class="bi bi-list"></i>
        </button>
        <div class="d-flex justify-content-between">
          <div class="dropdown me-4" ngbDropdown>
            <button class="btn btn-light bg-white border-0 btn-sm dropdown-toggle d-flex" id="dropdownBasic1" ngbDropdownToggle>
              <div>
                <img src={{user?.partnerId.logoPath}} class="ap-avatar">
              </div>
              <div class="text-start ms-2">
                <p class="mb-0 text-bold">{{user?.username}}</p>
                <small class="text-secondary text-start">{{user?.role}}</small>
              </div>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownBasic1" ngbDropdownMenu>
              <a routerLink="/app/profile" class="dropdown-item">Profile</a>
              <a routerLink="/app/reset-password" class="dropdown-item">Reset Password</a>
              <a routerLink="/app/mfa" class="dropdown-item">MFA</a>
              <a routerLink="/app/security-questions" class="dropdown-item">Security Questions</a>
              <button class="dropdown-item" (click)="onLogout()">Logout</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-2 border-end sideMenubar" id="sideMenubar"
      [class.menu-open]="menuOpen" [class.menu-collapsed]="!menuOpen">
      <div class="sidebar ps-2 pe-2 mt-2">
        @for (l of sideMenu; track l) {
          @if (!l.path) {
            <a class="rounded btn btn-sm w-100 mt-2 ps-2">{{l.title}}</a>
          }
          @if (l.path) {
            <a [routerLink]="l.path" class="rounded btn btn-sm w-100"
              [ngClass]="l.path === activeUrl ? 'btn-primary active rounded': ''">
              <i [class]="l.icon" class="me-2"></i>
              {{l.title}}
            </a>
          }
        }

      </div>
    </div>
    @if (isMobile && menuOpen) {
      <div class="menu-backdrop" (click)="closeMenu()"></div>
    }
    <div class="content" [ngClass]="menuOpen ? 'col-md-10' : 'col-12'">
      <div class="mt-2 mb-4">
        <router-outlet />
      </div>
    </div>
  </div>
</div>